<template>
  <div class="">
    <!-- Popular Movies Section Start -->
    <h2 class="text-orange-500 font-semibold uppercase tracking-wide">{{ title }}</h2>
    <div class="popular-movies text-sm
                        grid grid-cols-2
                        lg:grid-cols-5
                        xl:grid-cols-6 gap-12">
      <!-- Single Movie Section Start -->
      <div class="movie mt-8" v-for="movie in movies" :key="movie.id">
        <div class="relative inline-block">
          <router-link :to="{name: 'tv.detail', params: {id: movie.id}}">
            <img :src="imagePath(movie.poster_path)"
                 alt="movie cover"
                 class="hover:opacity-75 transition ease-in-out duration-150 rounded"
            >
          </router-link>
          <div class="absolute -bottom-5 -right-5
                                    w-16 h-16
                                    bg-gray-800 rounded-full" v-if="movie.vote_average"
          >
            <CircleProgress :percent="percent(movie)"
                            :viewport="true"
                            :border-width="10"
                            :border-bg-width="15"
                            empty-color="#4A5568"
                            fill-color="#48bb78"/>
            <div class="font-semibold text-xs relative -top-10 left-5">
              {{ movie.vote_average.toFixed(1) *10+'%' }}
            </div>
          </div>
        </div>
        <div class="mt-6">
          <router-link :to="{name: 'tv.detail', params: {id: movie.id}}"
                       class="hover:text-gray-400 block truncate
                                text-base font-semibold leading-tight mb-2">
            {{ movie.name ? movie.name: movie.title }}
          </router-link>
          <span class="bg-gray-700 px-2 py-1 text-xs rounded-full">
          {{ movie.first_air_date ? new Date(movie.first_air_date).toDateString() : new Date(movie.release_date).toDateString()}}
        </span>
          <div class="text-gray-400 mt-1">
<!--          <span class="" v-for="genre in movie.genre_ids">-->
<!--            {{ genre }}-->
<!--          </span>-->
            <span class="">
            <i class="fa-solid fa-star text-orange-500"></i>
            {{ Math.ceil(movie.popularity) }}
          </span>
          </div>
        </div>
      </div>
      <!-- Single Movie Section End -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CircleProgress from "vue3-circle-progress";

export default {
  name: "TvShow",
  components: {
    CircleProgress
  },
  props: ['movies', 'title'],
  data() {
    return {
      genreArray: [],
    }
  },
  methods: {
    imagePath(image) {
      return  'https://image.tmdb.org/t/p/w500/'+image;
    },
    percent(number){
      return number.vote_average*10;
    }
  },
  created() {
    let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
    axios.get(`https://api.themoviedb.org/3/genre/tv/list`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
        .then(res => this.genreArray = res.data.genres)
        .catch(error => console.log(error));

  }
}
</script>

<style scoped>
.vue3-circular-progressbar{
  height: auto !important;
  width: 3.95rem !important;
}
</style>